// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__3Qcp8","image":"App_image__2M_zF"};